<template>
  <v-menu
      v-model="show"
      :style="`position: absolute; left: ${x}px; top: ${y}px`"
      absolute
      offset-y
  >
    <v-list
    >
       <v-list-item
          v-if="addButton"
          density="compact"
          @click="$emit('add')"
          prepend-icon="mdi-plus"
      >

        <v-list-item-title>Add</v-list-item-title>
      </v-list-item>
      <v-list-item
          v-if="deleteButton"
          density="compact"
           prepend-icon="mdi-delete"
          @click="$emit('action')"
      >

        <v-list-item-title>Delete</v-list-item-title>
      </v-list-item>
    </v-list>
  </v-menu>
</template>
<script>
export default {
  name: 'TableActionMenu',
  props: {
    selectedItem: {},
    showMenu: {},
    addButton: {default: true, required: false},
    deleteButton: {default: true, required: false},
    x: {},
    y: {},
  },
  computed: {
    show: {
      get() {
        return this.showMenu
      },
      set(value) {
        this.$emit('update:showMenu', value)
      },
    },
  }
}
</script>